import { postApiCall} from "../utils/Api";

export const ListTotalStats = async (data) => {
    try {
      //console.log(data);
      const result = await postApiCall(`/api/v1/dashboard/statistics`,data,true);
      var apiresult = JSON.parse(result.data.message);
      return apiresult;
    } catch (e) {
      throw e;
    }
  };